import { ENUM_TIPO_PESSOA } from 'utils/consts';
import { convertDate } from 'utils/dateFormatter';
import { removeEspacos, removeTodasMascaras } from 'utils/stringFormatter';

const removerMascaraPessoaInputs = dadosInputs => {
  const {
    tipoPessoa,
    cpf,
    telefone,
    cep,
    inscricaoEstadual,
    inscricaoMunicipal,
    cnpj,
    dataNascimento,
    profissaoId,
    escolaridadeId,
    sexoId,
    instituicaoId,
    areaAtuacaoId,
    cargoRepresentante,
    enderecoPf,
    enderecoPj,
  } = dadosInputs;

  const dataNascimentoFormatada =
    dataNascimento?.toString()?.split('/')?.length > 1 ? convertDate(dataNascimento) : dataNascimento;

  const tipoPessoaFormatada =
    ENUM_TIPO_PESSOA.fisica.descricao === tipoPessoa ? ENUM_TIPO_PESSOA.fisica : ENUM_TIPO_PESSOA.juridica;

  return {
    ...dadosInputs,
    profissaoId: !profissaoId ? null : parseInt(profissaoId, 10),
    dataNascimento: !dataNascimentoFormatada ? null : dataNascimentoFormatada,
    cargoRepresentante: !cargoRepresentante ? null : cargoRepresentante,
    escolaridadeId: !escolaridadeId ? null : parseInt(escolaridadeId, 10),
    instituicaoId: !instituicaoId ? null : parseInt(instituicaoId, 10),
    areaAtuacaoId: !areaAtuacaoId ? null : parseInt(areaAtuacaoId, 10),
    sexoId: !sexoId ? null : parseInt(sexoId, 10),
    tipoPessoa: tipoPessoaFormatada,
    cpf: !cpf ? null : parseInt(removeTodasMascaras(cpf), 10),
    telefone: telefone ? parseInt(removeEspacos(removeTodasMascaras(telefone)), 10) : null,
    cep: !cep ? null : parseInt(removeTodasMascaras(cep), 10),
    enderecoPf: {
      ...enderecoPf,
      cep: !enderecoPf?.cep ? null : parseInt(removeTodasMascaras(enderecoPf?.cep), 10),
    },
    enderecoPj: {
      ...enderecoPj,
      cep: !enderecoPj?.cep ? null : parseInt(removeTodasMascaras(enderecoPj?.cep), 10),
    },
    inscricaoEstadual: !cnpj ? null : parseInt(removeTodasMascaras(inscricaoEstadual), 10),
    inscricaoMunicipal: !cnpj ? null : parseInt(removeTodasMascaras(inscricaoMunicipal), 10),
    cnpj: !cnpj ? null : parseInt(removeTodasMascaras(cnpj), 10),
  };
};

export const formatarPessoaFisicaFrontToBack = dados => {
  dados = removerMascaraPessoaInputs(dados);

  return {
    nome: dados.nome,
    nomeSocial: dados.nomeSocial,
    cpf: dados.cpf,
    dataNascimento: dados.dataNascimento,
    profissaoId: dados.profissaoId,
    sexoId: dados.sexoId,
    escolaridadeId: dados.escolaridadeId,
    email: dados.email,
    telefone: dados.telefone,
    tipoPessoaId: dados.tipoPessoa.id,
    cnpj: dados.cnpj,
    inscricaoEstadual: dados.inscricaoEstadual,
    inscricaoMunicipal: dados.inscricaoMunicipal,
    razaoSocial: dados.razaoSocial,
    instituicaoId: dados.instituicaoId,
    areaAtuacaoId: dados.areaAtuacaoId,
    cargoRepresentante: dados.cargoRepresentante,
    endereco: {
      cep: dados.cep,
      logradouro: dados.logradouro,
      numero: dados.numero,
      bairro: dados.bairro,
      complemento: dados.complemento,
      cidade: dados.cidade,
      estado: dados.estado,
      pais: dados.pais,
      id: 0,
    },
    id: 0,
  };
};

export const formatarPessoaJuridicaFrontToBack = dados => {
  dados = removerMascaraPessoaInputs(dados);

  return {
    nome: dados.nome,
    nomeSocial: dados.nomeSocial,
    cpf: dados.cpf,
    dataNascimento: dados.dataNascimento,
    profissaoId: dados.profissaoId,
    sexoId: dados.sexoId,
    escolaridadeId: dados.escolaridadeId,
    email: dados.email,
    telefone: dados.telefone,
    tipoPessoaId: dados.tipoPessoa.id,
    cnpj: dados.cnpj,
    inscricaoEstadual: dados.inscricaoEstadual,
    inscricaoMunicipal: dados.inscricaoMunicipal,
    razaoSocial: dados.razaoSocial,
    instituicaoId: dados.instituicaoId,
    areaAtuacaoId: dados.areaAtuacaoId,
    cargoRepresentante: dados.cargoRepresentante,
    endereco: {
      cep: dados.cep,
      logradouro: dados.logradouro,
      numero: dados.numero,
      bairro: dados.bairro,
      complemento: dados.complemento,
      cidade: dados.cidade,
      estado: dados.estado,
      pais: dados.pais,
      id: 0,
    },
    id: 0,
  };
};
